










import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableInnerGroup extends Vue {
  @Prop() private variableList!: any;
  @Prop() private index!: number;
  @Prop() private groupLabel!: string;
}
